import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './locales/fr/common.json'
import auth from './locales/fr/auth.json'
import articles from './locales/fr/articles.json'
import generation from './locales/fr/generation.json'
import articleDetail from './locales/fr/articleDetail.json'
import topics from './locales/fr/topics.json'
import tenants from './locales/fr/tenants.json'
import deliveries from './locales/fr/deliveries.json'
import ops from './locales/fr/ops.json'
import research from './locales/fr/research.json'
import localeAudit from './locales/fr/localeAudit.json'
import desk from './locales/fr/desk.json'
import settings from './locales/fr/settings.json'
import seo from './locales/fr/seo.json'

export const namespaces = [
  'common',
  'auth',
  'articles',
  'generation',
  'articleDetail',
  'topics',
  'tenants',
  'deliveries',
  'ops',
  'research',
  'localeAudit',
  'desk',
  'settings',
  'seo',
] as const

void i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: namespaces,
  resources: {
    fr: {
      common,
      auth,
      articles,
      generation,
      articleDetail,
      topics,
      tenants,
      deliveries,
      ops,
      research,
      localeAudit,
      desk,
      settings,
      seo,
    },
  },
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
